import {
  GET_USERS_MERCHANT_APPLICATION_SUCCESS,
  GET_USER_CAN_MAKE_APPLICATION_SUCCESS,
  GET_USER_CAN_APPROVE_AGREEMENT_SUCCESS,
  ADD_MERCHANT_APPLICATION_SUCCESS,
  MERCHANT_APPLICATION_API_ERROR,
  APPROVE_MERCHANT_AGREEMENT_SUCCESS,
  UPLOAD_MERCHANT_FILE_SUCCESS,
  UPLOAD_MERCHANT_FILE_LIST_SUCCESS,
  DELETE_MERCHANT_FILE_SUCCESS,
  GET_MERCHANT_APPLICATION_DOCUMENT_SUCCESS,
  GET_MERCHANT_APPLICATION_DOCUMENT_FILE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
  recordList: [],
  merchant: {},
  recordDocumentList:[],
  applicationRecieved: false,
  agreementsCreated: false,
  canApproveAgreement: false,
  canMakeApplication: false,
  fileUploadTaxNo: [],
  fileDeleteResponse: [],
  fileUploadResponse: [],
  waitingResponse: false,
  fileViewData:{},
  waitingFileBase64String: false,
  error: {},
}


const merchantApplication = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USERS_MERCHANT_APPLICATION_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case GET_USER_CAN_MAKE_APPLICATION_SUCCESS:
      return {
        ...state,
        canMakeApplication: action.payload.canMakeApplication,
      }
    case GET_USER_CAN_APPROVE_AGREEMENT_SUCCESS:
      return {
        ...state,
        canApproveAgreement: action.payload.canApproveAgreement,
      }
    case ADD_MERCHANT_APPLICATION_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        applicationRecieved: true,
        canMakeApplication: false,
        canApproveAgreement: false,
      }

    case APPROVE_MERCHANT_AGREEMENT_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        agreementsCreated: true,
        canApproveAgreement: false,
        canMakeApplication: false,
      }
    case UPLOAD_MERCHANT_FILE_SUCCESS:
      return {
        ...state,
        fileUploadResponse: [...state.fileUploadResponse, action.payload.result],
        waitingResponse: !state.waitingResponse
      }
    case UPLOAD_MERCHANT_FILE_LIST_SUCCESS:
      return {
        ...state,
        fileUploadResponse: [...state.fileUploadResponse, action.payload.result],
        waitingResponse: !state.waitingResponse
      }
    case DELETE_MERCHANT_FILE_SUCCESS:
      return {
        ...state,
        fileDeleteResponse: [...state.fileDeleteResponse, action.payload],
      }
      case GET_MERCHANT_APPLICATION_DOCUMENT_SUCCESS:
        return {
          ...state,
          recordDocumentList: action.payload,
        }
        case GET_MERCHANT_APPLICATION_DOCUMENT_FILE_SUCCESS:
          return {
            ...state,
            fileViewData: action.payload,
            waitingFileBase64String: !state.waitingFileBase64String,

          }
    case MERCHANT_APPLICATION_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:

      return state

  }
}

export default merchantApplication